/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: helpers.js
 * Created by: chan.ying
 * Create Date: 2026-04-27 15:58
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import {mapState, mapActions} from 'vuex'

export const layoutComputed = {
    ...mapState('layout', {
        layoutType: (state) => state.layoutType,
        leftSidebarType: (state) => state.leftSidebarType,
        // layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar,
        loader: (state) => state.loader,
        theme: (state) => state.theme,
    })
}

export const layoutMethods = mapActions('layout', [
    'changeLayoutType',
    'changeLayoutWidth',
    'changeLeftSidebarType',
    'changeTopbar',
    'changeLoaderValue',
    'changeTheme',
])

export const notificationMethods = mapActions('notification', [
    'success',
    'error',
    'clear'
])